// Import Firebase SDK
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBxs6wcNJ5mJJhTUoZWxRCoTdie3yk9g9c",
  authDomain: "vastrebyvijh-8c454.firebaseapp.com",
  projectId: "vastrebyvijh-8c454",
  storageBucket: "images.vastrebyvijh.com", // 👈 FIX: must be *.appspot.com
  messagingSenderId: "538286790757",
  appId: "1:538286790757:web:2545dadb67d51abaf54e8c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Correct way to init Firestore with named database
export const db = getFirestore(app, "vastrebyvijh-v1");

export const storage = getStorage(app);
export const bucketName = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'us-east1'); // Default for most functions
export const functionsAsiaSouth1 = getFunctions(app, 'asia-south1'); // For sendOrderNotification and createRazorpayOrder
export const functionsUsCentral1 = getFunctions(app, 'us-central1'); // For sendMail, setAdminClaim, checkAdminStatus, getAdminEmails, and Calendly functions

// Simple constants
export const IMAGE_SIZES = [480, 768, 1080, 1440, 1920];
export const STORAGE_PATHS = {
  CATEGORIES: 'vastre-images/categories',
  PRODUCTS: 'vastre-images/products',
  SIZE_CHARTS: 'vastre-images/size-charts'
};

// Admin user management functions
export const checkAdminStatus = async (user) => {
  if (!user) return false;
  
  try {
    // First check if user already has admin claim
    const token = await user.getIdTokenResult(true); // Force refresh
    
    // If user has admin claim, return true
    if (token.claims.admin === true) {
      return true;
    }
    
    // If no admin claim, try to set it using Firebase Function
    try {
      const setAdminClaim = httpsCallable(functionsUsCentral1, 'setAdminClaim');
      const result = await setAdminClaim();
      
      // Force token refresh to get new claims
      await user.getIdToken(true);
      
      return true;
    } catch (functionError) {
      return false;
    }
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};

export const setAdminClaim = httpsCallable(functionsUsCentral1, 'setAdminClaim');

export default app;
export { httpsCallable };
